import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { 
  ClassOutlined, 
  Star, 
  Add, 
  Edit, 
  Close, 
  Delete, 
  ArrowBack
} from '@mui/icons-material';
import { 
  styled as muiStyled
} from '@mui/material/styles';
import {
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Modal,
  Select,
  Switch,
  TextField,
  IconButton,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText
} from '@mui/material';
import COLOR from 'utils/constants/color';
import Loading from 'components/Loading';
import ModalMenu from 'components/Modals';
import Tag from 'components/Tag';
import moment from 'moment';
import styled from 'styled-components';
import { CheckCreteia } from 'components/AssignmentAiConfig';
import { Col, Row } from 'antd';
import { Tooltip } from 'antd';
import { filter, find, get, map, has, uniqBy } from "lodash";
import { groupLinkedSection, isVideo } from 'utils/lib/ebookHelper';
import { handleCreateStudentGroup, handleDelteStudentGroup } from 'store/studentGroup/thunks';
import { getCurrentSemStartAndEndDate, isAfterTime, isBeforTime } from 'utils/methods/math';
import { useParentOrgId } from 'store/organizations/selectors';

import { updateStudentGroup } from 'store/studentGroup/actions';
import { useBookOrder, useUserAllowedBooks } from 'store/books/selectors';
import { useCanvasAssignmentCategory } from 'store/canvas/selectors';
import { useComponentVisible } from 'containers/chat/hooks';
import { useCurrentUser } from 'store/users/selectors';
import { useResources } from 'store/resources/selectors';
import { useRubrices } from 'store/rubric/selectors';
import { useStudentGroup } from 'store/studentGroup/selectors';
import { useUsersByClass } from "store/userClasses/selectors";
import { handleListUserClasses } from 'store/userClasses/thunks';
import CustomDateTimePicker from "components/DateTimePicker";
import { findIndex , omit } from "lodash";
import useCurrentAssignment from 'components/hooks/assignment/useCurrentAssignment';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import useIsExamActive from 'components/hooks/books/useIsExamActive';
import SentryWrap from 'components/Sentry';
import dayjs from 'utils/dayjsConfig';
import { shouldUseDeepLinking, getLtiLaunchCanvasCourseId } from 'utils/deepLinkHelper';

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------












const levels = [
    {
        id: '1',
        value: 'easy',
        label: '2'
    },
    {
        id: '2',
        value: 'medium',
        label: '3'
    },
    {
        id: '3',
        value: 'hard',
        label: '4'
    }
]


const ClassNameText = styled.div`
   font-size:18px;
   font-weight:bold;
   text-align: left;
   text-transform: uppercase;
   line-break: anywhere;
`;
const ModalInnerWrapper = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    max-width: 550px;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow:scroll;
    max-height: 90vh; 
    min-width:450px;
`;
const ClassConfigContainer = styled.div`
    // max-height: 500px;
    // overflow-y: auto;
    // overflow-x: hidden;
    padding: 12px;
`;

const Container = styled.div`
    border-top: 1px solid ${COLOR.black700};
    margin-top: 24px;
    padding-top: 40px;
    width: 100%;
`;
const Note = styled.span`
    color: ${COLOR.black400};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 16px;
`;
const CrossSection = styled.span`
    border: 1px solid;
    padding: 10px;
    margin-top: 30px;
    position: relative;
`;
const SectionTitle = styled.div`
    font-size: 14px;
    color: #ffffff;
    background: ${COLOR.tabActive};
    padding: 4px 8px;
    border-radius: 6px !important;
    cursor: pointer;
    position: absolute;
    top: -15px;
    padding-left: 24px;
    padding-right: 24px;
    font-weight: bold;
    letter-spacing: 0.5px;
`;

const RubricSubContainerDiv = styled.div`
  padding-inline: 20px;
  padding-top: 4px;
  padding-bottom: 4px;
`;

const RubricContainerDiv = styled.div`
  justify-content: space-between;
  border: 1px solid darkgrey;
  border-radius: 12px;
  align-items: center;
  boxShadow: 0px 0px 10px rgba(0,0,0,0.2);
  transition: all 0.3s ease-in-out;
  &:hover {
  box-shadow: ${(p) => (p.loader ? "" : "0px 0px 10px rgba(0,0,0,0.3)")};
  // transform: scale(1.02);
  },
`;

const AssignedGroupContainer = styled.div`
  justify-content: space-between;
  border: 2px solid ${COLOR.green};
  background-color: rgba(76, 175, 80, 0.05);
  border-radius: 12px;
  align-items: center;
  boxShadow: 0px 0px 10px rgba(76, 175, 80, 0.3);
  transition: all 0.3s ease-in-out;
  &:hover {
    box-shadow: ${(p) => (p.loader ? "" : "0px 0px 15px rgba(76, 175, 80, 0.4)")};
  },
`;

const AssignedIndicator = styled.span`
  color: ${COLOR.green};
  font-size: 12px;
  margin-left: 8px;
  font-weight: bold;
  background-color: rgba(76, 175, 80, 0.1);
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid ${COLOR.green};
`;
const FormControlRoot = muiStyled('div')({
    marginBottom: '25px',
    width: '300px'
});

const FormControlDif = muiStyled('div')({
    width: '200px'
});

const FormControlDifFull = muiStyled('div')({
    width: "100%"
});

const SwitchSizeSmall = muiStyled('div')(({ theme }) => ({
    width: '55px',
    height: '25px'
}));

const SwitchChecked = muiStyled('div')(({ theme }) => ({
    transform: 'translateX(30px) !important'
}));

const StyledLabel = muiStyled('div')(({ theme }) => ({
    textTransform: 'uppercase'
}));

const ColorPrimary = muiStyled('div')(({ theme }) => ({
    color: `${COLOR.green}!important`
}));

const StyledFormControl = muiStyled(FormControl)(({ theme }) => ({
    margin: '2px',
    width: "100%",
    minWidth: 120
}));

const StyledFormControlStudent = muiStyled(FormControl)({
    backgroundColor: "#fff"
});

const StyledChips = muiStyled('div')({
    display: 'flex',
    flexWrap: 'wrap'
});

const StyledChip = muiStyled(Chip)({
    margin: 2
});

const StyledMenuItem = muiStyled(MenuItem)(({ selected }) => ({
    backgroundColor: selected ? "rgba(0, 0, 0, 0.08)" : undefined,
    "&:hover": {
        backgroundColor: selected ? "rgba(0, 0, 0, 0.08)" : undefined
    }
}));

const StyledListItemText = muiStyled(ListItemText)({
    fontWeight: 500
});

const StyledCheckbox = muiStyled(Checkbox)({
    '&.Mui-indeterminate': {
        color: "#f50057"
    }
});

const StyledFormControlLabel = muiStyled(FormControlLabel)({
    '&.rootDifFull': {
        width: "fit-content"
    }
});

const StyledSwitch = muiStyled(Switch)({
    '&.MuiSwitch-sizeSmall': {
        width: '55px',
        height: '25px'
    },
    '& .Mui-checked': {
        transform: 'translateX(30px) !important'
    }
});

const GropInput = styled.div`
    position: absolute;
    top: 30px;
    background: white;
    width: 200px;
    z-index: 9999999999;
    box-shadow: -1px 1px 4px gray, 1px 0px 4px gray;
    border-radius: 5px;
    padding: 4px;
`;

 const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
    white-space: nowrap;
    `;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
    getContentAnchorEl: () => null,
};

const MultiMenu = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
    variant: "menu",
    getContentAnchorEl: () => null,
};
function getStyles(name, studentsName, theme) {
    return {
        fontWeight:
            studentsName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

function GroupMenu({ onInput, studentGroupData, classInfo }) {
    const dispatch = useDispatch();
    const [inputValue, setInputValue] = useState('');
    const {
        ref,
        isComponentVisible,
        setIsComponentVisible
    } = useComponentVisible(false);


    useEffect(()=>{
        if(studentGroupData?.selectedDataForDiff && Object.keys(studentGroupData?.selectedDataForDiff)?.length > 0){
            setIsComponentVisible(false)
        }
    },[studentGroupData?.selectedDataForDiff])
  
    const handleClick = (event) => {
      setIsComponentVisible(true)
    };  
    const handleOkClick = () => {
      onInput(inputValue)
      setIsComponentVisible(false)
    };

      const diffMenu = {
        items: [
          {
            key: 'create',
            label: (
              <PaddedBtn
                onClick={(e) => {
                  e.preventDefault();
                  handleClick();
                }}
              >
                Create Differentiation
              </PaddedBtn>
            ),
            style: { padding: "0px" },
            className: "contextCenter"
          },
          {
            key: 'reuse',
            label: (
              <PaddedBtn
                onClick={async (e) => {
                  e.preventDefault();
                  const filterData = studentGroupData?.teacherData?.filter((x) => x?.class_id === classInfo?.id);
                  await dispatch(updateStudentGroup({open: true, type: "selectDiffernation", selection_data_for_diff:filterData }))
                }}
              >
                Reuse Differentiation
              </PaddedBtn>
            ),
            style: { padding: "0px" },
            className: "contextCenter"
          }
        ]
      };

        
  
    return (
      <div style={{ position:"relative"}}>
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
            <Button
                color="primary"
                onClick={() => handleClick()}
                startIcon={<Add />}

            >
                Group
            </Button>
            </div>

        {isComponentVisible?<GropInput ref={ref}>
            <div onClick={e=>e?.preventDefault()}>
            <TextField 
              label="Group Name" 
              value={inputValue} 
              onChange={(e) => setInputValue(e.target.value)} 
            />
          </div>
          <Button 
              color="primary"  
              onClick={handleOkClick}
              
            >
              OK
            </Button>
        </GropInput>:null}
      </div>
    );
  }
const mapToClass = (availableClass, id, classes, data, currentClass) => {
    const classToInclude = availableClass.find(cls => cls.id === id);

    if (!classToInclude) {
        return classes;
    }

    const hasClass = classes.find(cls => cls.id === id);

    if (hasClass) {
        if (id === currentClass?.id) {
            return classes;
        }
        if (classes.length === 1) {
            return classes;
        }
        const removed = classes.filter(cls => cls.id !== id);
        return removed;
    } else {
        const newClass = {
            displayName: classToInclude.displayName,
            dueDate: data.dueDate,
            id: classToInclude.id,
            scheduleAt: data.scheduleAt,
            sectionId: classToInclude.sectionId,
            schoologyCategory: null,
                diff: {
                id: classToInclude.id,
                retakesDif: 0,
                levelExercise: 'hard',
                dueDateDif: moment().add(1, 'day').toISOString(),
                scheduleAtDiff: moment().toISOString(),
                student: [],
                groups:[],
                timeDuration: 0
            }
        };

        const result = classes ? [...classes, newClass] : [newClass];
        return result;
    }
}

const AlreadyAssignedMessage = ({isFromAlreadyAssigned}) =>{
    if(!isFromAlreadyAssigned) return null;
    return (
        <Typography
            variant="caption"
            color="textSecondary"
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' , color: COLOR.redishpink }}>
            (It is already assigned to this class)
        </Typography>
    )
}

function MultiSelecter({ options, onSelect, defaultValue }) {
    const [selected, setSelected] = useState([]);
    const [initialLoaded, setInitialLoaded] = useState(false);
    const isAllSelected = options.length > 0 && selected.length === options.length;

    const handleChange = (event) => {
        const value = event.target.value;
        if (value[value.length - 1] === "all") {
            setSelected(selected.length === options.length ? [] : options);
            onSelect(selected.length === options.length ? [] : options);
            return;
        }
        onSelect(value);
        setSelected(value);
    };

    useEffect(() => {
        if (defaultValue && selected.length == 0 && !initialLoaded) {
            if (defaultValue.length > 0) {
                setSelected(filter(options, k => defaultValue.includes(k.id)));
            } else {
                setSelected(options);
            }
            setInitialLoaded(true);
        }
    }, [defaultValue, options]);

    return (
        <StyledFormControlStudent variant="outlined" className='setInputLabel'>
            <InputLabel id="mutiple-select-label" style={{ backgroundColor: "#fff" }}>Select students</InputLabel>
            <Select
                labelId="mutiple-select-label"
                multiple
                value={selected}
                onChange={handleChange}
                displayEmpty
                renderValue={(selected) => (
                    <StyledChips>
                        {`${isAllSelected || selected.length == 0 ? "All students" : "Students(" + selected.length + ")"}`}
                    </StyledChips>
                )}
                MenuProps={MultiMenu}
            >
                <StyledMenuItem
                    value="all"
                    selected={isAllSelected}
                >
                    <ListItemIcon>
                        <StyledCheckbox
                            checked={isAllSelected}
                            indeterminate={selected.length > 0 && selected.length < options.length}
                        />
                    </ListItemIcon>
                    <StyledListItemText primary="Select All" />
                </StyledMenuItem>
                {options.map((option) => (
                    <MenuItem key={option.id} value={option}>
                        <ListItemIcon>
                            <Checkbox checked={Boolean(find(selected, k => k.id === option.id))} />
                        </ListItemIcon>
                        <ListItemText primary={`${option.lastName || ''}, ${option.firstName || ''}`} />
                    </MenuItem>
                ))}
            </Select>
        </StyledFormControlStudent>
    );
}

const GroupListing = ({
    groups,
    onSelectGroup,
    existingGroups = [],
    onUnassignGroup,
    onDeleteExistingGroup,
    onAssignGroup,
    getRespDataType
  }) => {
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [groupToDelete, setGroupToDelete] = useState(null);

    const handleSwitchChange = async (group, checked) => {
      if (checked) {
        try {
          if (onAssignGroup) {
            onAssignGroup(group);
          } else if (onSelectGroup) {
            onSelectGroup(group);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        if (onUnassignGroup) {
          onUnassignGroup(group.key || group.id);
        }
      }
    };

    const handleDeleteClick = (group) => {
      setGroupToDelete(group);
      setDeleteConfirmOpen(true);
    };

    const handleDeleteConfirm = () => {
      if (groupToDelete && onDeleteExistingGroup) {
        onDeleteExistingGroup(groupToDelete.key || groupToDelete.id);
      }
      setDeleteConfirmOpen(false);
      setGroupToDelete(null);
    };

    const handleDeleteCancel = () => {
      setDeleteConfirmOpen(false);
      setGroupToDelete(null);
    };

    const isGroupAssigned = (group) => {
      return groups.some(g => g.key == group.key ||g.id == group.id );
    };
    // Combine all groups into a single list
    const allGroups = [...groups , ...existingGroups.filter(g => !groups.some(eg => eg.key == g.key)).map(getRespDataType)];
    return (
      <>
        {allGroups.length === 0 ? (
          <div className="bubbleNotesNoData text-blue-10">
            No differentiation groups are available. Please add them.
          </div>
        ) : (
          <div className="w-full flex flex-col gap-10px mt-16px overflow-auto px-10px py-10px">
            {allGroups.map((data) => {
              const assigned = isGroupAssigned(data);
              const ContainerComponent = assigned ? AssignedGroupContainer : RubricContainerDiv;
              
              return (
                <ContainerComponent
                  key={data.id || data.key}
                  className="flex flex-col items-start cursor-pointer"
                >
                  <RubricSubContainerDiv className="flex items-center justify-between w-full">
                    <div className="w-full text-start rubricData-title flex items-center">
                      <span className="text-wrap">
                        {data?.display_name || data?.group_name}
                        {assigned && (
                          <AssignedIndicator>
                            ✓
                          </AssignedIndicator>
                        )}
                        <br />
                      </span>
                    </div>
                    <div className="flex items-center gap-8px" style={{ gap: '8px' }}>
                      {/* Edit Button - Always available */}
                      <Button 
                        onClick={(e) => {
                          e.stopPropagation();
                          onSelectGroup(data);
                        }}
                        size="small"
                        style={{ minWidth: 'auto', padding: '4px' }}
                      >
                        <Edit
                          className="cursor-pointer text-green-10"
                          style={{
                            fontSize: 16,
                            transition: "all 0.3s ease-in-out",
                          }}
                        />
                      </Button>

                      {/* Delete Button - Only for unassigned existing groups */}
                      {!assigned && existingGroups.some(eg => eg.id == data.id) && (
                        <Button 
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteClick(data);
                          }}
                          size="small"
                          color="secondary"
                          style={{ minWidth: 'auto', padding: '4px' }}
                        >
                          <Delete
                            className="cursor-pointer text-red-10"
                            style={{
                              fontSize: 16,
                              transition: "all 0.3s ease-in-out",
                            }}
                          />
                        </Button>
                      )}

                      {/* Assign/Unassign Switch */}
                      <Switch
                        checked={assigned}
                        onChange={(e) => {
                          e.stopPropagation();
                          handleSwitchChange(data, e.target.checked);
                        }}
                        color="primary"
                        size="small"
                        style={{ marginLeft: '4px' }}
                      />
                    </div>
                  </RubricSubContainerDiv>
                </ContainerComponent>
              );
            })}
          </div>
        )}

        {/* Delete Confirmation Modal */}
        <Dialog
          open={deleteConfirmOpen}
          onClose={handleDeleteCancel}
          aria-labelledby="delete-dialog-title"
          aria-describedby="delete-dialog-description"
        >
          <DialogTitle id="delete-dialog-title">
            Delete Differentiation Group
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="delete-dialog-description">
              Are you sure you want to delete the group "{groupToDelete?.display_name || groupToDelete?.group_name}"? 
              This action cannot be undone and will permanently remove this group from your available groups.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteCancel} color="primary">
              Cancel
            </Button>
            <Button onClick={handleDeleteConfirm} color="error" variant="contained">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };
const ConfigArea = ({ data, listStudents, onChangeDone , onBackClick , onDelete, currentUser,classInfo , assignment_data, is_exam = false }) => {
    const [selectedStudent, setSelectedStudent] = useState([])
    const [scheduledDiffDate, setScheduledDiffDate] = useState()
    const [levelExercise, setLevelExercise] = useState("hard")
    const [diffDate, setDiffDate] = useState()
    const [retake, setRetake] = useState()
    const [initalConfig, setInitalConfig] = useState(null);
    const hasDiff = selectedStudent.length > 0;
    const [durationSection, setDurationSection] = useState(false)
    const [timeDuration, setTimeDuration] = useState(0)
    const dispatch  = useDispatch();
    const [ai_grading_config,setAiGradingConfig] = useState({})
    const [selectedRubrics, setRubrics] = useState(null);
    const AllRubricsData = useRubrices();
    const selectedRubricData =  useMemo(()=>find(AllRubricsData,k=>k.id==selectedRubrics),[AllRubricsData,selectedRubrics])
    const [loader, setLoader] = useState(false);
    const isEditing = get(data, "editing", false);
    const  {checkAssignmentHaveSubmission} = useCurrentAssignment(data?.data?.id);

    const hasdiffConfigError = () => {
        if(loader){
            return true;
        }
        if (!scheduledDiffDate || !diffDate) return true;
        else if (moment(scheduledDiffDate).isAfter(diffDate)) {
            return true;
        }
        return !hasDiff;
    }
    useEffect(() => {
        const todayDtime = moment().toISOString()
        const nextDtime = moment().add(1, "day").toISOString()
        if (data) {
            setSelectedStudent(get(data, 'student', []))
            if (data.scheduleAtDiff) {
                setScheduledDiffDate(get(data, 'scheduleAtDiff'))
            } else {
                setScheduledDiffDate(todayDtime)
            }
            if (data.levelExercise) {
                setLevelExercise(get(data, 'levelExercise'))
            } else {
                setLevelExercise('hard')
            }
            if (data.dueDateDif) {
                setDiffDate(get(data, 'dueDateDif', nextDtime))
            } else {
                setDiffDate(nextDtime)
            }
            if (data.retakesDif >= 0) {
                setRetake(get(data, 'retakesDif', 0))
            } else {
                setRetake(0)
            }
            if(data.ai_grading_config){
                setAiGradingConfig(data.ai_grading_config)
            }
            if(data.rubrics_id){
                setRubrics(data.rubrics_id)
            }
            if(data.timeDuration !== undefined && data.timeDuration !== null){
                setTimeDuration(data.timeDuration)
                setDurationSection(data.timeDuration > 0)
            } else {
                setTimeDuration(0)
                setDurationSection(false)
            }

        } else {
            setScheduledDiffDate(todayDtime)
            setLevelExercise('hard')
            setDiffDate(nextDtime)
            setRetake(0)
            setSelectedStudent([])
            setTimeDuration(0)
            setDurationSection(false)
        }
        if (data && (!initalConfig || initalConfig.id != data.id)) {
            setInitalConfig(data)
        } else {
            setInitalConfig(null)
        }
    }, [data])
    const getStartMintime = (value) => {
        if (value) {
            return isBeforTime(moment(value).toISOString()) ? moment(value).toISOString() : moment().toISOString()
        } else {
            return moment().toISOString()
        }
    }
    const getMinDate = (date1, date2) => {
        if (date1 && date2) {
            return isBeforTime(date1, date2) ? moment(date2).add(1, "minute").toISOString() : moment(date1).add(1, "minute").toISOString();
        } else if (date1 || date2) {
            return date1 ? moment(date1).add(1, "minute").toISOString() : moment(date2).add(1, "minute").toISOString();
        } else {
            return moment().toString()
        }
    }

    const onDone = async () => {
        setLoader(true);
        let payload = {
            config: selectedStudent,
            number_of_answer: levelExercise,
            total_attempts: retake,
            created_by: currentUser?.id,
            group_name: data?.display_name || data.group_name,           
            class_id: classInfo?.id,
            key:data.key,
            ai_grading_config,
            rubrics_id:selectedRubrics,
            timeDuration: durationSection ? timeDuration : 0
           }
           if(!data?.customCreated){
             payload.id = data?.id
           }
        if (!data?.customCreated) {
            dispatch(handleCreateStudentGroup(payload, currentUser.id));
        } else {
            await dispatch(handleCreateStudentGroup(payload, currentUser.id));
        }
        onChangeDone({
            ...data,
            key:data.key,
            retakesDif: retake,
            levelExercise: levelExercise,
            dueDateDif: diffDate,
            scheduleAtDiff: scheduledDiffDate,
            student: selectedStudent,
            ai_grading_config,
            rubrics_id:selectedRubrics,
            timeDuration: durationSection ? timeDuration : 0
        })
       await dispatch(updateStudentGroup({selectedDataForDiff: {}, selection_data_for_diff: [], preSelectedGroup: {}}))
       setLoader(false);
    }
    const onDeleteItem = async () => {
    dispatch(updateStudentGroup({selectedDataForDiff: {}, preSelectedGroup: {} }))
        if(onDelete){
            onDelete(data.key)
        }
    }

//     const handleCheckboxChange = (e) => {
//     setIsChecked(e.target.checked);
//   };

    return (<>
        <Row gutter={[16, 24]} style={{ width:"100%" }}>
              <Button startIcon={<ArrowBack />} onClick={onBackClick} >Back</Button>
        </Row>
        <Row gutter={[16, 24]} className="durDateSpc" style={{ marginTop: 0 }}>
            <Col span={24}>
            <ClassNameText style={{ fontSize:14 , fontWeight:"400" , textAlign:"center" , borderBottom:"0.5px dotted"}}> {data.display_name || ''}</ClassNameText>
            </Col>
        </Row>
        <ClassConfigContainer>
            <Row gutter={[24, 24]} className="selectStudents" style={{ width: '100%', paddingLeft: 5 }}>
                <StyledFormControl style={{ marginTop: '15px' }}>
                    <InputLabel className="selectStudentsLbl" id="bookList-label">Select students</InputLabel>
                    <Select
                        labelId="mutiple-select-label"
                        multiple
                        value={selectedStudent}
                        onChange={v => {
                            setSelectedStudent(v.target.value)
                        }}
                        displayEmpty
                        renderValue={(selected) => (
                            <StyledChips>
                                {selected.map((value) => {
                                    const student = find(listStudents, k => k.id == value)
                                    const label = student ? `${student.lastName || ''}, ${student.firstName || ''}` : ''
                                    return (
                                        <StyledChip key={value} label={label} />
                                    )
                                })}
                            </StyledChips>
                        )}
                        MenuProps={MultiMenu}
                    >
                        {map(listStudents, (option) => (
                            <MenuItem key={option.id} value={option.id}>
                                <ListItemIcon>
                                    <Checkbox checked={Boolean(find(selectedStudent, k => k == option.id))} />
                                </ListItemIcon>
                                <ListItemText primary={`${option.lastName || ''}, ${option.firstName || ''}`} />
                            </MenuItem>
                        ))}
                    </Select>
                </StyledFormControl>
            </Row>
            <Row gutter={[16, 24]} className="durDateSpc">
                <Col span={24}>
                    <CustomDateTimePicker
                        id="scheduleAtDiff"
                        label="Start Date Differentiation"
                        popupAboveModal
                        inputVariant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        defaultValue={null}
                        // disabled={((checkAssignmentHaveSubmission && isEditing) || (currentUser?.googleId) || (currentUser?.schoologyid)) ? true : false}
                        disabled = {checkAssignmentHaveSubmission && isEditing ? true : false}
                        format="MM-dd-yyyy hh:mm a"
                        minDate={getStartMintime(get(initalConfig, "scheduleAtDiff"))}
                        minDateMessage={`Start date and time has to be after the ${moment(getStartMintime(get(initalConfig, "scheduleAtDiff"))).format("MM-DD-YYYY hh:mm a")} `}
                        initialFocusedDate={moment().toString()}
                        value={scheduledDiffDate}
                        onChange={e => {
                            setScheduledDiffDate(e.toISOString())
                        }} />
                </Col>
                <Tag height={20}><Star style={{ height: '12px', margin: '-1px 4px 0px 0px', width: '12px' }} /> NOTE</Tag>
                <Note>The assignment will take effect after the scheduled date and time.</Note>
            </Row>
            <Row gutter={[16, 24]} style={{ margin: '25px -8px 12px' }}>
                <Col span={24}>
                    <CustomDateTimePicker
                        id="dueDateDif"
                        label="Due Date Differentiation"
                        popupAboveModal
                        inputVariant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        defaultValue={null}
                        format="MM-dd-yyyy hh:mm a"
                        minDate={getMinDate(scheduledDiffDate)}
                        strictCompareDates
                        initialFocusedDate={moment().toString()}
                       // minDateMessage={"Due Date and Time has to be after the Start Date and Time."}
                        value={diffDate}
                        onChange={e => {
                            setDiffDate(e.toISOString())
                        }} />
                </Col>
                <Col span={24}>
                    <StyledFormControlStudent variant="outlined">
                        <InputLabel style={{ backgroundColor: "#fff" }}>Select number of answers</InputLabel>
                        <Select
                            id="levelExercise"
                            value={levelExercise || ''}
                            onChange={e => setLevelExercise(e.target.value)}
                            label="Select number of answers"
                            displayEmpty
                        >
                            {map(levels, level => (
                                <MenuItem key={level.id} value={level.value}>
                                    {level.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </StyledFormControlStudent>
                </Col>
            </Row>
            <Container>
                <Row justify="start" style={{ marginBottom: 10 }}>
                    <StyledFormControlLabel
                        className="rootDifFull"
                        control={
                            <StyledSwitch
                                checked={durationSection}
                                id="timeDuration"
                                onChange={e => {
                                    if (!e.target.checked) {
                                        setTimeDuration(0)
                                    }
                                    setDurationSection(e.target.checked)
                                }}
                                name="timeDuration"
                                color="primary"
                                size="small"
                            />
                        }
                        label={<StyledLabel>Set a TIME-LIMIT for this assessment</StyledLabel>}
                    />
                </Row>
                {durationSection &&
                    <Row gutter={[16, 24]} style={{ marginTop: 16 }}>
                        <Col span={24}>
                            <TextField
                                id="timeDuration"
                                onChange={e => {
                                    const val = parseInt(e.target.value, 10) || 0
                                    setTimeDuration(val)
                                }}
                                variant="outlined"
                                label="Duration in minutes"
                                value={parseInt(timeDuration, 10) || 0}
                                type="number"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                InputProps={{
                                    inputProps: {
                                        min: 0,
                                        onWheel: (e) => e.target.blur()
                                    }
                                }}
                            />
                        </Col>
                    </Row>
                }
            </Container>
             <Row style={{ display: "flex", position: "relative", width: "100%", marginTop: 8 }}>
            <ModalMenu
                type={"selectRubricModal"}
                addedRubric={selectedRubricData}
                editable={assignment_data}
                setAddedRubric={(val) => {
                    setRubrics(val?.id)
                }}
                resetConfig={() => {
                    setRubrics(null)
                }}
            />
            </Row>
              <Row style={{ display: "flex", position: "relative", width: "100%", marginTop: 8  , border:"0.5px solid #d9d9d9", padding:"4px" }}>
                 <CheckCreteia creteria={ai_grading_config} onCreteriaChange={setAiGradingConfig} original_conf={assignment_data?.ai_grading_config?.creteria} is_exam={is_exam} />

            </Row>
            <Container>
                <Row gutter={[16, 24]}>
                    <Col span={16}>
                        <Tag height={20}><Star style={{ height: '12px', margin: '-1px 4px 0px 0px', width: '12px' }} /> NOTE</Tag>
                        <Note>This is the differentiation number of total attempts the differentiation student will have for this quiz.</Note>
                    </Col>
                    <Col span={8}>
                        <TextField
                            id="retakesDif"
                            onChange={e => {
                                if (e.target.value < 0 || e.target.value > 100) {
                                    return;
                                }
                                setRetake(e.target.value)
                            }}
                            variant="outlined"
                            value={parseInt(retake, 10) || 0}
                            type="number"
                            InputProps={{
                                inputProps: {
                                    min: 0
                                }
                            }}
                        />
                    </Col>
                </Row>
                {/* <div className='flex items-center gap-10px'>
                        <Checkbox 
                            checked={isChecked} 
                            onChange={handleCheckboxChange}
                            style={{ marginRight: 8 }}
                            />
                           
                    {data ? "Update the Differentiation set" : "Create the Differentiation set"}
                </div> */}
                   
                <Row gutter={[16, 24]} style={{ marginTop: 16, width: "100%" }}>
                    <Col span={12} style={{ display: "flex", justifyContent: "flex-start" }}>
                        {hasDiff && <Button color="secondary" variant='contained' onClick={onDeleteItem}>
                            <Delete style={{ color:"#fff"}} /> 
                        </Button>}
                        {listStudents?.length === 0 ? (
                            <FormHelperText error>
                                {`There are no students remaining to be added to this group.`}
                            </FormHelperText>
                        ) : null}
                    </Col>
                    <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                        <Button  color="primary" variant='contained' disabled={hasdiffConfigError()} onClick={onDone}>
                            {loader ? <Loading white={true} size={16} /> : "done"}
                        </Button>
                    </Col>
                </Row>
            </Container>

        </ClassConfigContainer>
    </>)
}
const ClassDiffConfig = ({ diffConfigModal, setDiffConfigModal, data, listStudents, onChangeDone , classInfo, currentUser, assignment_data, is_exam = false}) => {
    const [editAreaOpen,setEditAreaOpen] = useState(false);
    const [ groupToEdit , setGroupToEdit] = useState({});
    const [groups,setGroups] = useState([]);
    const [userToBeSelect , setUserToBeSelect] = useState([])
    const [existingGroups, setExistingGroups] = useState([]);
    const studentGroupData = useStudentGroup();
    const dispatch = useDispatch();

    const resolvedListStudents = useMemo(() => {
        if (typeof listStudents === 'function') {
            try {
                return listStudents() || [];
            } catch {
                return [];
            }
        }
        return Array.isArray(listStudents) ? listStudents : [];
    }, [listStudents, classInfo?.id]);

    useEffect(() => {
        setGroups( data.groups||[])
    },[data])

    useEffect(() => {
        Promise.allSettled([
            dispatch(updateStudentGroup({groupsData: groups}))
        ])
    },[groups])

    // Fetch existing groups for the class
    useEffect(() => {
        const userGroups =  uniqBy([...(studentGroupData?.teacherData||[]),...(studentGroupData?.data||[])], "id")
        if (classInfo?.id && userGroups) {
            const classGroups = userGroups.filter((x) => x?.class_id === classInfo.id);
            setExistingGroups(classGroups);
        }
    }, [classInfo?.id, studentGroupData])

    useEffect(() => {
        if(Object.keys(groupToEdit).length>0){
             setUserToBeSelect(resolvedListStudents)
            // if(groups.length==0){
            //     setUserToBeSelect(listStudents)
            // }else{
            //     const otherGroup = groups.filter(k=>k.key!=groupToEdit.key)
            //     const alredySelected = otherGroup.flatMap(k=>k.student)
            //     const to_be_selectable = listStudents.filter(k=>!alredySelected.includes(k.id))
            //     setUserToBeSelect(to_be_selectable)
            // }
        }
     }, [groupToEdit,groups,resolvedListStudents])
    const getRespDataType = useCallback((conf) => {
        let omit_value = omit(conf,["config","number_of_answer","total_attempts","group_name"])
        return {
            ...omit_value,
            student: conf.student || conf?.config,
            levelExercise: conf.levelExercise || conf?.number_of_answer,
            retakesDif: conf?.retakesDif || conf?.total_attempts,
            key: conf?.key || Math.floor(Math.random() * 1000),
            id: conf?.id,
            dueDateDif: conf.dueDateDif || moment().endOf('day').toISOString(),
            scheduleAtDiff: conf.scheduleAtDiff || moment().toISOString(),
            display_name: conf.display_name || conf.group_name,
            timeDuration: conf.timeDuration || 0,
        };
    }, [])

    useEffect(() => {
      const selectedDataForDiff = studentGroupData?.selectedDataForDiff;
       if (
        selectedDataForDiff &&
         Object.keys(selectedDataForDiff).length > 0 
       ) {
         const dataForGroup = {
           student: selectedDataForDiff?.config,
           levelExercise: selectedDataForDiff?.number_of_answer,
           retakesDif: selectedDataForDiff?.total_attempts,
           key: selectedDataForDiff?.key || Math.floor(Math.random() * 1000),
           id: selectedDataForDiff?.id,
           dueDateDif: "",
           scheduleAtDiff: "",
           display_name: selectedDataForDiff.group_name,
           timeDuration: selectedDataForDiff?.timeDuration || 0,
         };
         setGroupToEdit(dataForGroup)
         setEditAreaOpen(true);
       }
     }, [studentGroupData?.selectedDataForDiff]);

     // Handle pre-selected group from existing groups
     useEffect(() => {
       const preSelectedGroup = studentGroupData?.preSelectedGroup;
       if (preSelectedGroup && Object.keys(preSelectedGroup).length > 0) {
         const dataForGroup = {
           student: preSelectedGroup?.config || [],
           levelExercise: preSelectedGroup?.number_of_answer || 'hard',
           retakesDif: preSelectedGroup?.total_attempts || 0,
           key: preSelectedGroup?.key||Math.floor(Math.random() * 1000),
           id: preSelectedGroup?.id,
           dueDateDif: moment().add(1, 'day').toISOString(),
           scheduleAtDiff: moment().toISOString(),
           display_name: preSelectedGroup.group_name,
           timeDuration: preSelectedGroup?.timeDuration || 0,
         };
         setGroupToEdit(dataForGroup)
         setEditAreaOpen(true);
         // Clear the preSelectedGroup after using it
         dispatch(updateStudentGroup({ preSelectedGroup: {} }));
       }
     }, [studentGroupData?.preSelectedGroup, dispatch]);

     const AddDataOnGroup = () => {
       try {
         const selectedDataForDiff = studentGroupData?.selectedDataForDiff;
         if (
           selectedDataForDiff &&
           Object.keys(selectedDataForDiff).length > 0
         ) {
           const dataForGroup = {
             student: selectedDataForDiff?.config,
             levelExercise: selectedDataForDiff?.number_of_answer,
             retakesDif: selectedDataForDiff?.total_attempts,
             key:selectedDataForDiff?.key ||  Math.floor(Math.random() * 1000),
             id: selectedDataForDiff?.id,
             dueDateDif: "",
             scheduleAtDiff: "",
             display_name: selectedDataForDiff.group_name,
             timeDuration: selectedDataForDiff?.timeDuration || 0,
           };
           setGroups([...groups, dataForGroup]);
         }
       } catch (error) {
         console.log(error);
       }
     };


    const onDone = (dt) => {
        AddDataOnGroup();
        let grp = [...groups]
        const index = findIndex(grp, k => k.key == groupToEdit.key)
        if (index > -1) {
            grp[index] = getRespDataType(dt)
        } else {
            grp.push(getRespDataType(dt))
        }
        setGroups(grp)
        if (onChangeDone) {
            onChangeDone({
                ...data,
                groups: grp
            })
        }
        setEditAreaOpen(false)
    }

    const handleGroupSelect = (item) => {
        setEditAreaOpen(true);
        setGroupToEdit(item);
    }

    const onAssignGroup = (item) => {
        let grp = [...groups]
        const formattedGroup = getRespDataType(item)
        const index = findIndex(grp, k => k.key == formattedGroup.key || k.id == formattedGroup.id)
        if (index === -1) {
            grp.push(formattedGroup)
            setGroups(grp)
            if (onChangeDone) {
                onChangeDone({
                    ...data,
                    groups: grp
                })
            }
        }
    }

   const onDeleteExistingGroup = (groupKey) => {
     // Remove from existing groups list
     let existingGrp = [...existingGroups]
     const index = findIndex(existingGrp, k => k.key == groupKey || k.id == groupKey)
     if (index > -1) {
        dispatch(handleDelteStudentGroup(existingGroups[index].id))
       existingGrp.splice(index, 1)
       setExistingGroups(existingGrp)
     }
     
     // Also remove from selected groups if it exists there
     let grp = [...groups]
     const selectedIndex = findIndex(grp, k => k.key == groupKey || k.id == groupKey)
     if (selectedIndex > -1) {
       grp.splice(selectedIndex, 1)
       onChangeDone({
         ...data,
         groups: grp
       })
       setGroups(grp)
     }
   }  
   const onDelete = (key) =>{
    if (onChangeDone) {
        let grp = [...groups]
        const index = findIndex(grp, k => k.key == groupToEdit.key)
        if (index > -1) {
            grp.splice(index, 1)
        }
        onChangeDone({
          ...data,
          groups: grp
        })
        setGroups(grp)
        setEditAreaOpen(false)  
     }
   }

   const onUnassignGroup = (groupKey) => {
     if (onChangeDone) {
       let grp = [...groups]
       const index = findIndex(grp, k => k.key == groupKey || k.id == groupKey)
       if (index > -1) {
         grp.splice(index, 1)
         onChangeDone({
           ...data,
           groups: grp
         })
         setGroups(grp)
       }
     }
   }


   const onAddGroup = (text) =>{
    if(text) {
        let grp = [ ...groups ]
        const item = {
            key: Math.floor(Math.random()*100000),
            display_name: text,
            id: classInfo.id?classInfo.id:data?.id,
            retakesDif: 0,
            levelExercise: 'hard',
            dueDateDif: moment().endOf('day').toISOString(),
            scheduleAtDiff: moment().toISOString(),
            student: [],
            customCreated: true,
            timeDuration: 0
        }
        grp.push(item)
        setGroupToEdit(grp)
        setGroupToEdit(item)
        setEditAreaOpen(true)
    }
   }
    return (<>
    <Modal
        open={diffConfigModal}
        onClose={(e, r) =>{ 
            if(r == 'backdropClick') return null;
            dispatch(updateStudentGroup({selectedDataForDiff: {}, preSelectedGroup: {} }))
            setDiffConfigModal(false)
            setEditAreaOpen(false);
            setGroupToEdit({});
            return true;
        }}
    >
        <ModalInnerWrapper className='Diff_modalContainer'>
            <IconButton
                onClick={() => {
                    dispatch(updateStudentGroup({selectedDataForDiff: {}, preSelectedGroup: {} }))
                    setDiffConfigModal(false)
                    setEditAreaOpen(false);
                    setGroupToEdit({});
                }}
                style={{ padding: 0, marginRight: 10, position: "absolute", right: 0, top: 10 }}>
                <Close color="secondary" />
            </IconButton>
            <Row gutter={[16, 24]} className="durDateSpc">
                <Col span={24}>
                    <ClassNameText>Differentiation - {get(classInfo, "displayName")}</ClassNameText>
                </Col>
            </Row>
            <Row gutter={[16, 24]} style={{ width: "100%" }}>
                {!editAreaOpen ? (
                    <GroupMenu
                        studentGroupData={studentGroupData}
                        classInfo={classInfo}
                        onInput={onAddGroup}
                    />
                ) : null}
            </Row>
            <ClassConfigContainer style={{ width: "100%" }}>
                {editAreaOpen ? <ConfigArea assignment_data={assignment_data} classInfo={classInfo} currentUser={currentUser} data={groupToEdit} listStudents={userToBeSelect} onChangeDone={onDone} onBackClick={async () => { 
                    await dispatch(updateStudentGroup({selectedDataForDiff: {}, selection_data_for_diff: [], preSelectedGroup: {}}))
                    setEditAreaOpen(false) }} onDelete={onDelete} is_exam={is_exam} /> : <>
                    <GroupListing 
                        groups={groups} 
                        existingGroups={existingGroups}
                        onSelectGroup={handleGroupSelect} 
                        onUnassignGroup={onUnassignGroup}
                        onDeleteExistingGroup={onDeleteExistingGroup}
                        onAssignGroup={onAssignGroup}
                        classInfo={classInfo}
                        getRespDataType={getRespDataType}
                    />
                </>
                }
            </ClassConfigContainer>
           {!editAreaOpen&&<Row gutter={[16, 24]} style={{ marginTop: 16, width: "100%" }}>
                    <Col span={12} style={{ display: "flex", justifyContent: "flex-start" }}>
                       
                    </Col>
                    <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                        <Button color="primary" variant='contained'onClick={()=>setDiffConfigModal(false)}>
                            done
                        </Button>
                    </Col>
                </Row>}
        </ModalInnerWrapper>
    </Modal>
    </>)
}

function SchoologySelector({
  sb,
  data,
  schoologyAllClassGradeCategory,
  classes,
  initialClasses = [],
  updateClassConfig,
  is_edit=false
}) {
  const categories = schoologyAllClassGradeCategory[sb.sectionId] || [];
  const isSameClassId = (a, b) => a == b || String(a) === String(b);
  const classCfg = find(data.classes, (c) => c && isSameClassId(c.id, sb.id)) || {};
  const initialClassCfg = find(initialClasses, (c) => c && isSameClassId(c.id, sb.id)) || {};
  const schoologyCategoryId =
    get(classCfg, "schoologyCategory.id") ||
    get(classCfg, "schoologyCategory") ||
    get(initialClassCfg, "schoologyCategory.id") ||
    get(initialClassCfg, "schoologyCategory") ||
    get(data, "schoologyCategory");
  const selected = find(categories, (option) => option && isSameClassId(option.id, schoologyCategoryId));
//   const isPoint = selected?.calculation_type == '2';
   const isPoint = true;
  const defaultMax = selected?.default_max_points ?? 100;

  const [maxPoints, setMaxPoints] = useState(classCfg.maxPoints ?? defaultMax);
  const [factor,   setFactor]   = useState(classCfg.factor    ?? 1.0);

  // sync back up
  useEffect(() => { updateClassConfig(sb.id, 'maxPoints', maxPoints) }, [maxPoints]);
  useEffect(() => { updateClassConfig(sb.id, 'factor',   factor)   }, [factor]);

  const handleMaxChange = e => {
    const val = Math.max(1, parseInt(e.target.value, 10) || 1);
    setMaxPoints(val);
  };
  const handleFactorChange = e => {
    const val = Math.max(0, parseFloat(e.target.value) || 0);
    setFactor(val);
  };
  return (
    <SentryWrap>
      <Row gutter={[16, 16]} align="middle">
      <Col span={24}>
        <StyledFormControlStudent
          size="small"
          variant="outlined"
        >
          <InputLabel
            id="schoologyCategory"
            style={{ backgroundColor: '#fff', width: 'max-content' }}
          >
            Select Category
          </InputLabel>
          <Select
            labelId="schoologyCategory"
            value={selected || ''}
            onChange={e =>
              updateClassConfig(
                sb.id,
                'schoologyCategory',
                get(e.target.value, 'id')
              )
            }
            renderValue={sel => <ListItemText primary={sel?.title || ''} />}
            MenuProps={MenuProps}
          >
            {map(categories, option => (
              <MenuItem key={option.id} value={option}>
                <ListItemText
                  primary={`${option.title} (${option.weight ?? 100})`}
                />
              </MenuItem>
            ))}
          </Select>
        </StyledFormControlStudent>
      </Col>

      <Col span={24}>
        <InputContainer>
          {isPoint && (
            <TextField
              label="Max Points"
              type="number"
              variant="outlined"
              disabled={is_edit}
              size="small"
              value={maxPoints}
              onChange={handleMaxChange}
              InputProps={{ inputProps: { min: 1 } }}
            />
          )}

          <TextField
            label="Factor"
            type="number"
            variant="outlined"
            size="small"
            value={factor}
            onChange={handleFactorChange}
            InputProps={{ inputProps: { min: 0, step: 0.01 } }}
          />
        </InputContainer>
      </Col>
      </Row>
    </SentryWrap>
  );
}
export default function AssignmentClassConfig({
    data,
    userClasses = [],
    handleChange,
    currentClass,
    setErrorForDateConfig,
    errorForDateConfig,
    isSchoologyUser,
    schoologyAllClassGradeCategory,
    is_exam = false,
    alreadyAssignedClassIds = []
}) {
    const isEditing = get(data, "editing", false)
    const [classConfigModal, setClassConfigModal] = useState(false)
    const [diffConfigModal, setDiffConfigModal] = useState(false)
    const [selectedClassInfo, setselectedClassInfo] = useState({})
    const [selectedClassDiff, setSelectedClassDiff] = React.useState({});
    const [availableClasses, setAvailableClasses] = React.useState([]);
    const [initalData,setInitialData] = useState(null);
    const [fetchedUserClasses, setFetchedUserClasses] = useState(null);
    const hasAttemptedFetch = useRef(false);
    const dispatch = useDispatch();
    const usersByClass = useUsersByClass()
    const resources = useResources()
    const canvasAssignmentCategory =  useCanvasAssignmentCategory()
    const currentUser  = useCurrentUser()
    const isCanvasUser  = !!get(currentUser,"canvas_id")
    const allowed_books = useUserAllowedBooks()
    const bookOrder = useBookOrder();
    const  {checkAssignmentHaveSubmission} = useCurrentAssignment(data?.data?.id);
    const {checkAllTypeExamBook,checkNonAssignableBook} = useIsExamActive();


    useEffect(() => {
        if(!initalData||(data?.id!=initalData?.id)){
            setInitialData(data);
        }
    }, [data])

    useEffect(() => {
        const fetchUserClasses = async () => {
            if ((!userClasses || userClasses.length === 0) && currentUser?.id && !hasAttemptedFetch.current) {
                hasAttemptedFetch.current = true;
                try {
                    const fetchedClasses = await dispatch(handleListUserClasses(currentUser.id));
                    if (fetchedClasses && Array.isArray(fetchedClasses) && fetchedClasses.length > 0) {
                        setFetchedUserClasses(fetchedClasses);
                    } else {
                        setFetchedUserClasses([]);
                    }
                } catch (error) {
                    console.log(error, "error fetching user classes");
                    setFetchedUserClasses([]);
                }
            }
        };
        fetchUserClasses();
    }, [userClasses, currentUser?.id, dispatch]);

    useEffect(() => {
        try {
            let filteredClasses = [];
            const classesToUse = (userClasses && userClasses.length > 0) ? userClasses : (fetchedUserClasses || []);
            if (classesToUse && Array.isArray(classesToUse) && classesToUse.length > 0) {
                const chapter = get(data, "chapter") || get(data, "data.chapter");
                const bookId = get(data, "bookId") || get(data, "data.bookId");
                const extra_books = allowed_books.extra_books
                const group = bookOrder.filter(({ order }) => (order || []).some(k => k == bookId || k == chapter))
                const allGroup = group?.map(k => k.key);
                const isExamBook = checkAllTypeExamBook(bookId);
                const isNonAssignableBook = checkNonAssignableBook(chapter);
                
                filteredClasses = classesToUse.filter((x,index) => {
                    if (x.archived) {
                        return false;
                    }
                    const books_group = get(x, "books.books_group", []);
                    const archived_group = get(x,"books.archived_group",[]);
                    const current_active_groups = books_group.filter(k => !archived_group.includes(k));;

                   if(isExamBook || isNonAssignableBook){
                    return true;
                   }
                    else if (current_active_groups.length > 0) {
                        if (allGroup.some(k => current_active_groups.includes(k))) {
                           return true;
                        }else{
                            return false;
                        }
                    }
                      if (extra_books.some(k => k == bookId || k == chapter)) {
                        return true;
                    } else if (allowed_books.other_permissions.resourses && isVideo(chapter, resources)) {
                        return true;
                    }
                    return false;
                });
            }
            
          
            if (shouldUseDeepLinking()) {
                const ltiCanvasCourseId = getLtiLaunchCanvasCourseId();
                if (typeof ltiCanvasCourseId === 'string' && ltiCanvasCourseId.length > 2) {
                    filteredClasses = filteredClasses.filter(
                        (cls) => cls.canvas_course_id != null && String(cls.canvas_course_id) === ltiCanvasCourseId
                    );
                }
            }
            if (filteredClasses.length === 0 && currentClass && currentClass.id) {
                const isCurrentClassAlreadyInList = filteredClasses.some(cls => cls.id === currentClass.id);
                if (!isCurrentClassAlreadyInList) {
                    filteredClasses = [currentClass];
                }
            }
            setAvailableClasses(filteredClasses);
        } catch (error) {
            console.log(error, "error,quiz");
            if (currentClass && currentClass.id) {
                setAvailableClasses([currentClass]);
            } else {
                setAvailableClasses([]);
            }
        }
    }, [userClasses, fetchedUserClasses, resources, bookOrder, data, currentClass, allowed_books]);
      
    const updateClassConfig = (i, key, value,dt) => {
        const v = map(filteredDataClasses, (k) => {
            if (k.id == i) {
                k[key] = value;
                if(dt){
                    if(has(dt,"group_weight")){
                        k.canvas_weightage  = dt.group_weight;
                    }
                }
                return k;
            } else {
                return k;
            }
        })
        let val = { target: { id: "classes", value: v } }
        handleChange(val)
    }
    const getMinDate = (date1, date2) => {
        if (date1 && date2) {
            return isBeforTime(date1, date2) ? moment(date2).add(1, "minute").toISOString() : moment(date1).add(1, "minute").toISOString();
        } else if (date1 || date2) {
            return date1 ? moment(date1).add(1, "minute").toISOString() : moment(date2).add(1, "minute").toISOString();
        } else {
            return moment().toString()
        }
    }
    const updateError = (key, i, value) => {
        const errordata = errorForDateConfig;
        if (i >= 0 && i != null) {
            if (errordata.classCnfError[i]) {
                errordata.classCnfError[i][key] = value;
            } else {
                errordata.classCnfError[i] = {}
                errordata.classCnfError[i][key] = value;
            }
        } else {
            const errordata = errorForDateConfig;
            errordata[key] = value
        }
        setErrorForDateConfig(errordata)
    }
    const hasClassConfigError = () => {
        const v = errorForDateConfig.classCnfError.filter(k => Object.values(k).filter(v => v).length > 0)
        if (v.length > 0) return true;
        
        if (!data.classes || !Array.isArray(data.classes)) return false;
        
        const hasDateErrors = map(activeDataClasses, (cnf) => {
            const scheduleAt = get(cnf, "scheduleAt", get(data, "scheduleAt"));
            const dueDate = get(cnf, "dueDate", get(data, "dueDate"));
            const lateDate = get(cnf, "lateDate", get(data, "lateDate"));
            
            if (scheduleAt && dueDate && moment(scheduleAt).isAfter(moment(dueDate))) {
                return true;
            }
            if (scheduleAt && lateDate && moment(scheduleAt).isAfter(moment(lateDate))) {
                return true;
            }
            return false;
        });
        
        return hasDateErrors.some(error => error === true);
    }
    const getStartMintime = (value) => {
        if (value) {
            return isBeforTime(moment(value).toISOString()) ? moment(value).toISOString() : moment().toISOString()
        } else {
            return moment().toISOString()
        }
    }
    const onClassSelectorClick = (id) => {
        const newClasses = mapToClass(availableClasses, id, filteredDataClasses, data, currentClass);
        const v = { target: { id: "classes", value: newClasses } }
        handleChange(v)
    }
    const onSelectAllClassesClick = () => {
        const selectableClasses = getSelectableClasses();
        if (selectableClasses.length === 0) return;

        const allSelectableSelected = selectableClasses.every(cls =>
            isInDataClasses(filteredDataClasses, cls.id)
        );

        let newClasses = filteredDataClasses;

        if (allSelectableSelected) {
            selectableClasses.forEach(cls => {
                if (isInDataClasses(newClasses, cls.id)) {
                    newClasses = mapToClass(availableClasses, cls.id, newClasses, data, currentClass);
                }
            });
        } else {
            selectableClasses.forEach(cls => {
                if (!isInDataClasses(newClasses, cls.id)) {
                    newClasses = mapToClass(availableClasses, cls.id, newClasses, data, currentClass);
                }
            });
        }

        if (newClasses !== filteredDataClasses) {
            handleChange({ target: { id: "classes", value: newClasses } });
        }
    }
    const onDiffClick = (id) => {
        setDiffConfigModal(true)
        const classConf = find(data.classes, ['id', id])
        if (classConf) {
            if (classConf.diff.groups) {
                const diffItem = classConf.diff;
                delete diffItem.student;
                delete  diffItem.retakesDif
                delete diffItem.levelExercise
                delete diffItem.dueDateDif
                delete diffItem.scheduleAtDiff
                setSelectedClassDiff(diffItem)
            } else {
                if (classConf.diff.student?.length>0) {
                    const diffItem = classConf.diff;
                    delete diffItem.student;
                    delete  diffItem.retakesDif
                    delete diffItem.levelExercise
                    delete diffItem.dueDateDif
                    delete diffItem.scheduleAtDiff
                    const diff = { groups: [], id: id }
                    classConf.diff = diff
                    setSelectedClassDiff(diff)
                } else {
                    const diff = { groups: [], id: id }
                    setSelectedClassDiff(diff)
                }

            }
        } else {
            const diff = { groups: [], id: id }
            setSelectedClassDiff(diff)
        }
    }
    const crossed_courses = filter(availableClasses, k => k.canvas_cross_course_id)
    const non_crossed_courses = filter(availableClasses, k => !k.canvas_cross_course_id && !k.schoology_parent_id)
    const linked_classes = groupLinkedSection(availableClasses , isSchoologyUser)
    const listStudent = useCallback(()=>{
        return  get(usersByClass, get(selectedClassInfo, 'id'), []).filter(x => x.role == 'student')
    },[selectedClassInfo,usersByClass]);
    const getClassStudent = useCallback((class_id) => {
        const classUser = get(usersByClass, class_id, []) || [];
        return classUser.filter(x => x.role === 'student')
    }, [usersByClass])

    const showAlert = useAlert();
    const parentOrgId = useParentOrgId();
    const currentSemDateAndTime = getCurrentSemStartAndEndDate(parentOrgId);
    const openDueDateAlert = () =>{
        showAlert(`Assigning activities with due dates beyond the current semester is not possible.`, 'error')
    }
    const isSameClassId = (a, b) => a == b || String(a) === String(b);
    const isInDataClasses = (classes, classId) => Array.isArray(classes) && classes.some((c) => c && isSameClassId(c.id, classId));
    const isInAlreadyAssignedIds = (classId) => Array.isArray(alreadyAssignedClassIds) && alreadyAssignedClassIds.some((id) => isSameClassId(id, classId));
    const filteredDataClasses = Array.isArray(data.classes) ? data.classes : [];
    const activeDataClasses = filter(filteredDataClasses, (cnf) =>
        availableClasses.some((cls) => isSameClassId(cls.id, cnf.id))
    );
    const getClassFromData = (classes, classId) => find(classes, (c) => c && isSameClassId(c.id, classId));
    const getSelectableClasses = () => {
        const initialClasses = get(initalData, "classes", []);
        return availableClasses.filter(cls => {
            const isFromInitialEdit = Boolean(initalData && isInDataClasses(initialClasses, cls.id));
            const isFromAlreadyAssigned = isInAlreadyAssignedIds(cls.id);
            return !(isFromInitialEdit || isFromAlreadyAssigned);
        });
    };
    const selectableClasses = getSelectableClasses();
    const selectedSelectableCount = selectableClasses.filter(cls => isInDataClasses(filteredDataClasses, cls.id)).length;
    const allSelectableSelected = selectableClasses.length > 0 && selectedSelectableCount === selectableClasses.length;
    const someSelectableSelected = selectedSelectableCount > 0 && !allSelectableSelected;

    return (<SentryWrap>
        <Row gutter={[0, 24]} style={{ width: '100%' }}>
            <Col span={24}>
                <StyledFormControl variant="outlined">
                    <InputLabel id="classLabel">Classes</InputLabel>
                    <Row style={{ display: 'flex', justifyContent: 'flex-end'}}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={allSelectableSelected}
                                    indeterminate={someSelectableSelected}
                                    disabled={isEditing || selectableClasses.length === 0}
                                    onChange={onSelectAllClassesClick}
                                    color="primary"
                                />
                            }
                            label="Select all"
                            style={{ margin: 0 }}
                        />
                    </Row>
                     {Object.keys(linked_classes).length>0?Object.keys(linked_classes).map(lin_sec=>(<CrossSection>
                        <SectionTitle>Linked section</SectionTitle>
                        {map(linked_classes[lin_sec], sb => {
                            const initialClassesLinked = get(initalData, "classes", []);
                            const isFromInitialEdit = Boolean(initalData && isInDataClasses(initialClassesLinked, sb.id));
                            const isFromAlreadyAssigned = isInAlreadyAssignedIds(sb.id);
                            const isAlreadyAssigned = isFromInitialEdit || isFromAlreadyAssigned;
                            const isChecked = isInDataClasses(filteredDataClasses, sb.id) || isFromAlreadyAssigned;
                            return (<React.Fragment key={sb.id}>
                            <div $checked={isChecked} $disabled={isEditing || isAlreadyAssigned}>
                            <Row className='differRwCstm' style={{ margin: " 10px 0px" }}>
                                <Col span={8} style={{ display: "flex", alignItems: "center" }}>
                                <Tooltip title={sb.displayName || ''}>
                                <div style={{display:"grid"}}>
                                    <MenuItem key={sb.id}
                                        style={{ height: 35  , paddingLeft:5}}
                                        disabled={isEditing || isAlreadyAssigned}
                                        value={sb}
                                        onClick={() => {
                                            if (!isAlreadyAssigned) onClassSelectorClick(sb.id)
                                        }}>
                                        <ListItemIcon>
                                            <Checkbox
                                                checked={isChecked}
                                                disabled={isAlreadyAssigned}
                                                onChange={e => { }} />
                                        </ListItemIcon>
                                        {/* <Tooltip title={sb.displayName || ''}> */}
                                        <ListItemText primary={sb.displayName && sb.displayName.length > 10
                                            ? `${sb.displayName.substring(0, 30)}...`
                                            : sb.displayName || ''} />
                                    {/* </Tooltip> */}
                                    </MenuItem>
                                   <AlreadyAssignedMessage isFromAlreadyAssigned={isFromAlreadyAssigned} />
                                    </div>
                                    </Tooltip>
                                </Col>
                                <Col span={8} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    {isChecked && !isFromAlreadyAssigned && !isEditing && <Button color="primary" onClick={() => {
                                        onDiffClick(sb.id)
                                        setselectedClassInfo(sb)
                                    }}>
                                        {get(getClassFromData(filteredDataClasses, sb.id), "diff.groups.length", 0) > 0 ? <Edit /> : <Add />}  Differentiation
                                    </Button>}
                                </Col>
                                <Col span={8} style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >
                                        {isSchoologyUser && isChecked &&
                                            <SchoologySelector
                                                schoologyAllClassGradeCategory={schoologyAllClassGradeCategory}
                                                classes={filteredDataClasses}
                                                initialClasses={get(initalData, "classes", [])}
                                                data={data}
                                                updateClassConfig={updateClassConfig}
                                                is_edit={isEditing}
                                                sb={sb} />
                                        }
                                    {isCanvasUser && isChecked &&
                                        <StyledFormControlStudent size="small" variant="outlined">
                                            <InputLabel id="schoologyCategory" style={{ backgroundColor: "#fff", width: 'max-content' }}>Select Assignment Categories</InputLabel>
                                            <Select
                                                labelId="schoologyCategory"
                                                value={find(canvasAssignmentCategory[sb.canvas_id], ['id', get(getClassFromData(filteredDataClasses, sb.id), "canvas_assignment_catrgory")])}
                                                onChange={e => {
                                                    const catId = get(e.target.value, "id")
                                                    updateClassConfig(sb.id, "canvas_assignment_catrgory", catId, e.target.value)
                                                }}
                                                renderValue={(selected) => {
                                                    return (
                                                        <StyledChips>
                                                            <ListItemText primary={`${selected.name || ''}`} />
                                                        </StyledChips>
                                                    )
                                                }}
                                                MenuProps={MenuProps}
                                            >
                                                {map(canvasAssignmentCategory[sb.canvas_id], (option) => (
                                                    <MenuItem key={option.id} value={option}>
                                                        <ListItemText primary={`${option.name || ''} (${option.group_weight || '0'})`} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </StyledFormControlStudent>
                                    }
                                </Col>
                            </Row>
                            </div>
                        </React.Fragment>);
                        })}
                    </CrossSection>)):null}

                    {crossed_courses.length > 0 ? <CrossSection>
                        <SectionTitle>Cross-listed</SectionTitle>
                        {map(crossed_courses, sb => {
                            const initialClassesCrossed = get(initalData, "classes", []);
                            const isFromInitialEdit = Boolean(initalData && isInDataClasses(initialClassesCrossed, sb.id));
                            const isFromAlreadyAssigned = isInAlreadyAssignedIds(sb.id);
                            const isAlreadyAssigned = isFromInitialEdit || isFromAlreadyAssigned;
                            const isChecked = isInDataClasses(filteredDataClasses, sb.id) || isFromAlreadyAssigned;
                            return (<React.Fragment key={sb.id}>
                            <div $checked={isChecked} $disabled={isEditing || isAlreadyAssigned}>
                            <Row gutter={[16, 16]} className='differRwCstm' style={{ margin: " 20px 0px" }}>
                                <Col span={8} style={{ display: "flex", alignItems: "center", flexDirection:'column', gap:10 }}>
                                    <MenuItem key={sb.id}
                                        style={{ height: 35  , paddingLeft:5}}
                                        disabled={isEditing || isAlreadyAssigned}
                                        value={sb}
                                        onClick={() => {
                                            if (!isAlreadyAssigned) onClassSelectorClick(sb.id)
                                        }}>
                                        <ListItemIcon>
                                            <Checkbox
                                                checked={isChecked}
                                                disabled={isAlreadyAssigned}
                                                onChange={e => { }} />
                                        </ListItemIcon>
                                        <ListItemText style={{whiteSpace:'normal'}} primary={`${sb.displayName || ''}`} />
                                    </MenuItem>
                                    <AlreadyAssignedMessage isFromAlreadyAssigned={isFromAlreadyAssigned} />
                                </Col>
                                <Col span={8} style={{ display: "flex", alignItems: "center" }}>
                                    {isChecked && !isFromAlreadyAssigned && !isEditing && <Button color="primary" onClick={() => {
                                        onDiffClick(sb.id)
                                        setselectedClassInfo(sb)
                                    }}>
                                        {get(getClassFromData(filteredDataClasses, sb.id), "diff.groups.length", 0) > 0 ? <Edit /> : <Add />}  Differentiation
                                    </Button>}
                                </Col>
                                <Col span={8} style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >
                                        {isSchoologyUser && isChecked &&
                                            <SchoologySelector
                                                schoologyAllClassGradeCategory={schoologyAllClassGradeCategory}
                                                classes={filteredDataClasses}
                                                initialClasses={get(initalData, "classes", [])}
                                                data={data}
                                                updateClassConfig={updateClassConfig}
                                                is_edit={isEditing}
                                                sb={sb} />
                                        }
                                    {isCanvasUser && isChecked &&
                                        <StyledFormControlStudent size="small" variant="outlined">
                                            <InputLabel id="schoologyCategory" style={{ backgroundColor: "#fff", width: 'max-content' }}>Select Assignment Categories</InputLabel>
                                            <Select
                                                labelId="schoologyCategory"
                                                value={find(canvasAssignmentCategory[sb.canvas_id], ['id', get(getClassFromData(filteredDataClasses, sb.id), "canvas_assignment_catrgory")])}
                                                onChange={e => {
                                                    const catId = get(e.target.value, "id")
                                                    updateClassConfig(sb.id, "canvas_assignment_catrgory", catId, e.target.value)
                                                }}
                                                renderValue={(selected) => {
                                                    return (
                                                        <StyledChips>
                                                            <ListItemText primary={`${selected.name || ''}`} />
                                                        </StyledChips>
                                                    )
                                                }}
                                                MenuProps={MenuProps}
                                            >
                                                {map(canvasAssignmentCategory[sb.canvas_id], (option) => (
                                                    <MenuItem key={option.id} value={option}>
                                                        <ListItemText primary={`${option.name || ''} (${option.group_weight || '0'})`} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </StyledFormControlStudent>
                                    }
                                </Col>
                            </Row>
                            </div>
                        </React.Fragment>);
                        })}
                    </CrossSection> : null}



                    {map(non_crossed_courses, sb => {
                        const initialClassesNonCrossed = get(initalData, "classes", []);
                        const isFromInitialEdit = Boolean(initalData && isInDataClasses(initialClassesNonCrossed, sb.id));
                        const isFromAlreadyAssigned = isInAlreadyAssignedIds(sb.id);
                        const isAlreadyAssigned = isFromInitialEdit || isFromAlreadyAssigned;
                        const isChecked = isInDataClasses(filteredDataClasses, sb.id) || isFromAlreadyAssigned;
                        return (<React.Fragment key={sb.id}>
                        <div $checked={isChecked} $disabled={isEditing || isAlreadyAssigned}>
                        <Row className='differRwCstm' gutter={[16, 16]} style={{ margin: " 10px 0px" }}>
                            <Col xs={12} sm={12} md={8} style={{ display: "flex", alignItems: "center", overflow: "hidden" }}>
                            <Tooltip title={sb.displayName || ''}>
                                <div style={{display:"grid"}}>
                                <MenuItem key={sb.id}
                                    style={{ height: 35}}
                                    disabled={isEditing || isAlreadyAssigned}
                                    value={sb}
                                    onClick={() => {
                                        if (!isAlreadyAssigned) onClassSelectorClick(sb.id)
                                    }}>
                                    <ListItemIcon>
                                        <Checkbox
                                            checked={isChecked}
                                            disabled={isAlreadyAssigned}
                                            onChange={e => { }} />
                                    </ListItemIcon>
                                    {/* <ListItemText primary={`${sb.displayName || ''}`} /> */}
                                    {/* <Tooltip title={sb.displayName || ''}> */}
                                        <ListItemText primary={sb.displayName && sb.displayName.length > 14
                                            ? `${sb.displayName.substring(0, 20)}${sb.displayName.length > 20 ? '...' : ''}`
                                            : sb.displayName || ''} />
                                    {/* </Tooltip> */}
                                    {/* <ListItemText
                                        primary={
                                            <Tooltip title={sb.displayName || ''}>
                                            {sb.displayName && sb.displayName.length > 10
                                                ? `${sb.displayName.substring(0, 30)}...`
                                                : sb.displayName || ''}
                                            </Tooltip>
                                        }
                                        /> */}
                                </MenuItem>
                                <AlreadyAssignedMessage isFromAlreadyAssigned={isFromAlreadyAssigned} />
                                </div>
                                </Tooltip>
                            </Col>
                            <Col xs={12} sm={12} md={8} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                {isChecked && !isFromAlreadyAssigned && <Button color="primary" onClick={() => {
                                    onDiffClick(sb.id)
                                    setselectedClassInfo(sb)
                                }}>
                                    {get(getClassFromData(filteredDataClasses, sb.id), "diff.groups.length", 0) > 0 ? <Edit /> : <Add />}  Differentiation
                                </Button>}
                            </Col>
                            <Col xs={24} sm={24} md={8} style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >
                                {isSchoologyUser && isChecked &&
                                    <SchoologySelector
                                        schoologyAllClassGradeCategory={schoologyAllClassGradeCategory}
                                        classes={filteredDataClasses}
                                        initialClasses={get(initalData, "classes", [])}
                                        data={data}
                                        updateClassConfig={updateClassConfig}
                                        is_edit={isEditing}
                                        sb={sb} />
                                }
                                {isCanvasUser && isChecked &&
                                    <StyledFormControlStudent size="small" variant="outlined">
                                        <InputLabel id="schoologyCategory" style={{ backgroundColor: "#fff", width: 'max-content' }}>Select Assignment Categories</InputLabel>
                                        <Select
                                            labelId="schoologyCategory"
                                            value={find(canvasAssignmentCategory[sb.canvas_id], ['id', get(getClassFromData(filteredDataClasses, sb.id), "canvas_assignment_catrgory")])}
                                            onChange={e => {
                                                const catId = get(e.target.value, "id")
                                                updateClassConfig(sb.id, "canvas_assignment_catrgory", catId, e.target.value)
                                            }}
                                            renderValue={(selected) => {
                                                return (
                                                    <StyledChips>
                                                        <ListItemText primary={`${selected.name || ''}`} />
                                                    </StyledChips>
                                                )
                                            }}
                                            MenuProps={MenuProps}
                                        >
                                            {map(canvasAssignmentCategory[sb.canvas_id], (option) => (
                                                <MenuItem key={option.id} value={option}>
                                                    <ListItemText primary={`${option.name || ''} (${option.group_weight || '0'})`} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </StyledFormControlStudent>
                                }
                            </Col>
                        </Row>
                        </div>
                    </React.Fragment>);
                    })}
                </StyledFormControl>
            </Col>
        </Row>
        <Row>
            <Button color="primary" onClick={() => {
                setClassConfigModal(true)
            }}>
                <ClassOutlined /> CLASS CONFIGURATION
            </Button>
        </Row>
        <Modal
            open={classConfigModal}
            onClose={(e, r) => r == 'backdropClick' ? null : setClassConfigModal(false)}
        >
            <ModalInnerWrapper className='Diff_modalContainer'>
                <ClassConfigContainer>
                    {
                        map(activeDataClasses, (cnf, i) => {
                            const studentsData = getClassStudent(cnf.id);
                            return (<div key={cnf.id}>
                                <Row gutter={[16, 24]} className="durDateSpc">
                                    <Col span={24}>
                                        <ClassNameText>{cnf.displayName}</ClassNameText>
                                    </Col>
                                    <Col span={24}>
                                        <CustomDateTimePicker
                                            id="scheduleAt"
                                            label="Start Date"
                                            popupAboveModal
                                            inputVariant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            // disabled={((checkAssignmentHaveSubmission && isEditing) || (currentUser?.googleId) || (currentUser?.schoologyid)) ? true : false}
                                            disabled = {checkAssignmentHaveSubmission && isEditing ? true : false}
                                            format="MM-dd-yyyy hh:mm a"
                                            minDate={isEditing ? null : moment().toISOString()}
                                            //minDateMessage={`Start date and time  has to be after the ${moment(getStartMintime(get(cnf, "scheduleAt"))).format("MM-DD-YYYY hh:mm a")} `}
                                            minDateMessage={`${checkAssignmentHaveSubmission && isEditing? "This assignment has submissions so you can't modify the start date" : "Start date and time has to be after the current date and time."}`}
                                            initialFocusedDate={getMinDate()}
                                            defaultValue={null}
                                            value={get(cnf, "scheduleAt", get(data, "scheduleAt", moment().toString()))}
                                            onChange={e => {
                                                updateClassConfig(cnf.id, "scheduleAt", e.toISOString())
                                            }} 
                                             customError={`${checkAssignmentHaveSubmission && isEditing? "This assignment has submissions so you can't modify the start date" : ""}`}
                                            />
                                        {get(cnf, "scheduleAt", get(data, "scheduleAt")) && get(cnf, "dueDate", get(data, "dueDate")) && moment(get(cnf, "scheduleAt", get(data, "scheduleAt"))).isAfter(moment(get(cnf, "dueDate", get(data, "dueDate")))) && (
                                            <div style={{marginTop:5}}>
                                                <Typography style={{color:COLOR.red , fontSize:11, margin:0}}>Start date cannot be greater than due date.</Typography>
                                            </div>
                                        )}
                                        {get(cnf, "scheduleAt", get(data, "scheduleAt")) && get(cnf, "lateDate", get(data, "lateDate")) && moment(get(cnf, "scheduleAt", get(data, "scheduleAt"))).isAfter(moment(get(cnf, "lateDate", get(data, "lateDate")))) && (
                                                <div style={{marginTop:5}}>
                                                    <Note style={{color:COLOR.red , fontSize:11, margin:0}}>Start date must be before the late date.</Note>
                                                </div>
                                            )}
                                    </Col>
                                </Row>
                                <Row gutter={[16, 24]} style={{ marginTop: 16 }} className="durDateSpc">
                                    <Col span={24}>
                                        <CustomDateTimePicker
                                            id="dueDate"
                                            label="Due Date"
                                            popupAboveModal
                                            inputVariant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onError={e => {
                                                updateError("dueDate", i, e)
                                            }}
                                            strictCompareDates
                                            defaultValue={null}
                                            format="MM-dd-yyyy hh:mm a"
                                            minDate={getMinDate(get(cnf, "scheduleAt"))}
                                            initialFocusedDate={moment().toString()}
                                            minDateMessage={"Due Date and Time has to be after the Start Date and Time."}
                                            value={get(cnf, "dueDate", get(data, "dueDate", moment().toString()))}
                                            onChange={e => {
                                                if(!isBeforTime(e,currentSemDateAndTime.start)&& !isAfterTime(e,currentSemDateAndTime.end)){
                                                    updateClassConfig(cnf.id, "dueDate", e.toISOString())
                                                }else{
                                                    openDueDateAlert()
                                                }
                                            }} />
                                    </Col>
                                </Row>
                                <Row gutter={[16, 24]} style={{ marginTop: 16 }} className="durDateSpc">
                                    <Col span={24}>
                                        <MultiSelecter options={studentsData} onSelect={(value) => {
                                            if (value && value.length === studentsData.length) {
                                                updateClassConfig(cnf.id, "users", [])
                                            } else {
                                                updateClassConfig(cnf.id, "users", value.map(k => k.id))
                                            }
                                        }}
                                            defaultValue={get(cnf, "users", [])}
                                        />
                                    </Col>
                                </Row>
                                {get(data, "lateDate") ? (<Row gutter={[16, 24]} style={{ marginTop: 16 }}>
                                    <Col span={24}>
                                        <CustomDateTimePicker
                                            id="lateDate"
                                            label="Late Submission date"
                                            popupAboveModal
                                            inputVariant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onError={e => {
                                                updateError("lateDate", i, e)
                                            }}
                                            strictCompareDates
                                            format="MM-dd-yyyy hh:mm a"
                                            minDate={getMinDate(get(cnf, "dueDate"), get(cnf, "scheduleAt"))}
                                            defaultValue={null}
                                            initialFocusedDate={moment().toString()}
                                            minDateMessage={"Late Date and Time has to be after the Due Date and Time."}
                                            value={get(cnf, "lateDate", get(data, "lateDate")) == "always" ? undefined : get(cnf, "lateDate", get(data, "lateDate"))}
                                            onChange={e => {
                                                updateClassConfig(cnf.id, "lateDate", e.toISOString())
                                            }} />
                                    </Col>
                                </Row>) : null}
                            </div>)
                        })
                    }
                </ClassConfigContainer>
                <Row gutter={[16, 24]} style={{ marginTop: 16, display: "flex", justifyContent: "flex-end", width: "100%" , padding:"0px 24px"}}>
                   <Typography variant="caption" style={{color: COLOR.green100 }}>Selecting specific students limits the assignment to them; otherwise, it's available to the entire class.</Typography>
                </Row>
                <Row gutter={[16, 24]} style={{ marginTop: 16, display: "flex", justifyContent: "flex-end", width: "100%" }}>
                    <Button color="primary" variant='contained' disabled={hasClassConfigError()} onClick={() => {
                        setClassConfigModal(false)
                    }}>
                        Done
                    </Button>

                </Row>

            </ModalInnerWrapper>
        </Modal>
        {/*  diff config section */}
        <ClassDiffConfig
            diffConfigModal={diffConfigModal}
            setDiffConfigModal={setDiffConfigModal}
            listStudents={listStudent}
            data={selectedClassDiff}
            assignment_data={data}
            currentUser={currentUser}
            classInfo={selectedClassInfo}
            is_exam={is_exam}
            onChangeDone={v => {
                if (v && v.id) {
                    updateClassConfig(v.id, "diff", v)
                }
            }} />
    </SentryWrap>)
}